module.exports = __webpack_public_path__ + "img/78.9c6a70eb.jpg";